import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const LOGO_URL = 'https://i.imgur.com/1npk9MS.png';
const NAV_LINKS = [{
  label: 'Cabañas',
  href: '#cabanas'
}, {
  label: 'El Refugio',
  href: '#recorrido'
}, {
  label: 'Instalaciones',
  href: '#instalaciones'
}, {
  label: 'Cómo Llegar',
  href: '#como-llegar'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 70);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
  }, [mobileOpen]);
  return <nav className={`fixed top-0 inset-x-0 z-[1000] flex items-center justify-between px-6 sm:px-8 lg:px-12 transition-all duration-500 ${scrolled ? 'bg-night/95 backdrop-blur-xl py-3 border-b border-gold/10' : 'py-5'}`} data-id="element-395" data-mp="1kzq818kcgvkl">
      <a href="#inicio" className="flex items-center h-10 sm:h-11" data-id="element-396" data-mp="elzmyujpd2r2">
        <img src={LOGO_URL} alt="Refugio Caracolí" className="h-10 sm:h-11 w-auto max-w-[160px] object-contain object-left" data-id="element-397" data-mp="jmdqq0e9tqja" />
      </a>

      <ul className="hidden lg:flex items-center gap-10 list-none" data-id="element-398" data-mp="3n3mbas0dv4hp">
        {NAV_LINKS.map(link => <li key={link.href} data-id="element-399" data-mp="3s1xj6x74b4xa">
            <a href={link.href} className="group relative text-[0.72rem] font-medium tracking-[0.15em] uppercase text-white/70 transition-colors hover:text-gold" data-id="element-400" data-mp="3s38oj1g7okqi">
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" data-id="element-401" data-mp="5oz0wuk3vgqs" />
            </a>
          </li>)}
        <li data-id="element-402" data-mp="39ao9onxckg5p">
          <a href="#reserva" className="bg-gold text-night px-5 py-2 rounded-full text-[0.72rem] font-semibold tracking-[0.15em] uppercase transition-all hover:bg-gold-light hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,169,110,0.4)]" data-id="element-403" data-mp="39aeiix0kg2yf">
            Reservar
          </a>
        </li>
      </ul>

      <button onClick={() => setMobileOpen(v => !v)} aria-label="Menú" aria-expanded={mobileOpen} className="flex lg:hidden z-[1001] p-1" data-id="element-404" data-mp="361zwplvcaosz">
        {mobileOpen ? <XIcon className="w-6 h-6 text-white" data-id="element-405" data-mp="2ddc93jn4bnc9" /> : <MenuIcon className="w-6 h-6 text-white" data-id="element-406" data-mp="2dedvgk9l3w9a" />}
      </button>

      <AnimatePresence data-id="element-407" data-mp="2sabp9vw1coic">
        {mobileOpen && <motion.ul initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-night/[0.97] backdrop-blur-xl flex flex-col items-center justify-center gap-10 list-none z-[999]" data-id="element-408" data-mp="2sc6916vkmaku">
            {NAV_LINKS.map(link => <li key={link.href} data-id="element-409" data-mp="a4ixcsgvpwcn">
                <a href={link.href} onClick={() => setMobileOpen(false)} className="text-lg tracking-[0.2em] uppercase text-white/80" data-id="element-410" data-mp="a37ls6h6zkaz">
                  {link.label}
                </a>
              </li>)}
            <li data-id="element-411" data-mp="56h6vmh4iur5">
              <a href="#reserva" onClick={() => setMobileOpen(false)} className="bg-gold text-night px-6 py-2.5 rounded-full text-sm font-semibold tracking-[0.15em] uppercase" data-id="element-412" data-mp="55z7igz600f0">
                Reservar
              </a>
            </li>
          </motion.ul>}
      </AnimatePresence>
    </nav>;
}